import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';

import { ServiceRequestListWidgetConfiguration } from '../../../widgets/models/service-request-list-widget.model';
import {
  WidgetConfigurationComponent,
  WidgetConfigurationType,
} from '../../../widgets/models/widget-configuration.model';

@Component({
  selector: 'carehub-service-request-list-configuration',
  standalone: true,
  imports: [InputTextModule, InputNumberModule, ReactiveFormsModule],
  templateUrl: './service-request-list-widget-configuration.component.html',
  styleUrl: './service-request-list-widget-configuration.component.scss',
})
export class ServiceRequestListWidgetConfigurationComponent
  implements WidgetConfigurationComponent, OnInit {
  @Input() initialConfigurationuration?: WidgetConfigurationType;

  configForm: FormGroup;

  constructor(private formBuilder: FormBuilder) {
    this.configForm = this.formBuilder.group({
      header: ['', Validators.required],
      reloadDelay: [5, [Validators.required, Validators.min(1)]],
      searchTerm: [''],
    });
  }

  ngOnInit(): void {
    if (this.initialConfigurationuration) {
      this.configForm.patchValue(this.initialConfigurationuration);
    }
  }

  isValid(): boolean {
    return this.configForm.valid;
  }

  getConfiguration(): WidgetConfigurationType {
    return this.configForm.value as ServiceRequestListWidgetConfiguration;
  }
}
